import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "blog",
  "use": "blog-usage",
  "viewBox": "0 0 23.1 23.35",
  "content": "<symbol viewBox=\"0 0 23.1 23.35\" id=\"blog\"><rect x=\"0.95\" y=\"18.23\" width=\"8.56\" height=\"4.33\" rx=\"1.02\" ry=\"1.02\" transform=\"translate(-0.22 0.06) rotate(-0.62)\" /><rect x=\"13.79\" y=\"18.09\" width=\"8.55\" height=\"4.33\" rx=\"1.02\" ry=\"1.02\" transform=\"translate(-0.22 0.2) rotate(-0.62)\" /><rect x=\"0.85\" y=\"9.51\" width=\"21.4\" height=\"4.33\" rx=\"1.02\" ry=\"1.02\" transform=\"translate(-0.13 0.13) rotate(-0.62)\" /><rect x=\"0.76\" y=\"0.9\" width=\"12.84\" height=\"4.33\" rx=\"1.02\" ry=\"1.02\" transform=\"translate(-0.03 0.08) rotate(-0.62)\" /><rect x=\"17.88\" y=\"0.76\" width=\"4.28\" height=\"4.33\" rx=\"1.02\" ry=\"1.02\" transform=\"translate(-0.03 0.22) rotate(-0.62)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/blog.svg
// module id = 1171
// module chunks = 0